var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('minhas-licitacoes-hoje',{attrs:{"licitacoes":_vm.licitacoesHoje}}),_c('minhas-licitacoes-com-proposta'),_c('minhas-licitacoes-favoritas')],1)}
var staticRenderFns = []

export { render, staticRenderFns }